/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-02-27 20:42:27
 * @FilePath: /code/zeelool-nextjs/src/store/slices/globalSlice.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { StateCreator } from 'zustand';

import { fetchComplianceMarketingStatus } from '@/api/account';
import {
  Country,
  CountrySite,
  Currency,
  IMemberLevelConfig,
  PublicResourceData,
} from '@/api/types/public';
import type { ComplianceMarketingStatus } from '@/api/types/account';
import type { SgtmPixelConfig } from '@/services/sgtmPixelConfig';
import { Store } from '@/store';
import logger from '@/utils/client-logger';
import { checkFooterConfig, isInZeloolApp } from '@/utils/tools';

// 定义支持的语言类型
export type SupportedLanguage = 'en' | 'zh' | 'es' | 'fr' | 'de'; // 英文、中文、西班牙语、法语、德语
/**
 * 登录注册弹窗的展示场景。
 * payment 用于启用支付页专属布局、初始步骤和表单样式；
 * 不用于登录接口的 login_scene，接口场景由发起登录时的当前 pathname 决定。
 */
export type LoginRegisterScene = 'normal' | 'payment';

export interface ZoomDisablerType {
  zoom?: boolean;
  wheelZoom?: boolean;
  keyboardZoom?: boolean;
  doubleTapZoom?: boolean;
  contextMenu?: boolean;
}

/**
 * 客服相关状态
 */
export interface CustomerServiceState {
  showInstadesk: boolean; // 是否显示 Instadesk 弹窗
  instadeskUrl: string; // Instadesk URL
  deskType: string; // 客服类型：'instadesk' | 'zendesk' | 'shulex'
  /** Shulex iframe 弹窗（与 Instadesk 状态独立） */
  showShulexIframe: boolean;
  /** Shulex iframe 基址，来自 instadesk_chat.instadesk_url */
  shulexIframeUrl: string;
}

export interface GlobalState {
  isGlobalLoading: boolean;
  currentYear: number;
  waiMode: boolean; // 无障碍模式(Web Accessibility Initiative)
  language: SupportedLanguage; // 当前语言
  availableLanguages: SupportedLanguage[]; // 可用语言列表
  currencyList: Currency[]; // 所有币种列表
  currency: Currency; // 当前使用币种，默认美元
  currencyReady: boolean; // 币种是否已准备好(拉取接口结束，并且已设置币种)
  countryList: Country[]; // 国家列表
  countrySiteList: CountrySite[]; // 国家站点列表
  publicResourceData: PublicResourceData;
  inAppH5: boolean; // 是否在APP中
  isMobileScreen: boolean; // 是否是移动端屏幕，依靠的是屏幕宽度来判断
  walletFlag: boolean; // 电子钱包开关
  refreshOrderDetailFlag: boolean; // 刷新订单详情标志
  // 登录注册弹窗相关状态
  showLoginRegisterDialog: boolean; // 是否显示登录注册弹窗
  LoginRegisterInitiative: boolean; // 是否主动触发登录注册弹窗, 产品规定点击顶部导航“我的”按钮时，属于主动登录，其他场景均属于非主动注册场景
  loginRegisterInitialEmail: string; // 登录注册弹窗默认填入邮箱
  loginRegisterScene: LoginRegisterScene; // 弹窗展示/初始化场景，不是接口 login_scene
  loginRegisterEventType: string; // 登录注册事件类型
  loginSituation: string; // 登录场景
  onLoginClose: (type?: string) => void; // 登录弹窗关闭回调，type: 'login'|'register'|'close'|'back'
  inches: boolean; // 是否使用英寸单位
  isOpenSideNav: boolean; // 是否打开侧边导航
  isShowDtBanner: boolean; // 是否显示顶通 banner
  isShowDtBannerByPage: boolean; // 是否显示顶通 banner，根据页面来判断，该选项优先级高于isShowDtBanner
  isShowAppDownloadBanner: boolean; // 是否显示app下载 banner
  scrollHash: {
    top: number;
    flag: boolean;
  };
  isShowScrollToTop: boolean; // 是否显示滚动到顶部按钮
  isHalfStickyRightBottomIcons: boolean; // 是否显示半隐藏右侧底部图标
  isShowHeaderNav: boolean; // 是否显示头部导航
  isShowFooterNav: boolean; // 是否显示底部导航
  isHeaderDarkMode: boolean; // 是否显示头部导航暗色模式
  isShowFooterSubscribe: boolean; // 是否显示底部订阅框
  joinFreeDialogInfo: {
    show: boolean;
  }; // 是否显示入会弹窗

  publicHalfPrice: any; // 第二件半价折扣
  memberLevelConfig: IMemberLevelConfig; // 会员等级配置数据
  /** global init 下发的合规策略（按场景 key 索引，如 web.login）；与 publicResourceData 分离便于取用 */
  compliancePolicies: Record<string, { texts?: { content?: string }[] }> | null;
  /** 当前登录用户营销同意状态；undefined 表示未查询，null 表示查询失败/无数据 */
  complianceMarketingStatus?: ComplianceMarketingStatus | null;
  zoomDisablerType: ZoomDisablerType; // 禁用的操作类型
  // 客服相关状态
  customerService: CustomerServiceState;
  /** SGTM 像素开关配置，由服务端 10 分钟轮询刷新，SSR 注入 */
  sgtmPixelConfig: SgtmPixelConfig | null;
  /**
   * 首页 US WaterFall B 实验：非 null 表示从该 module 索引之后隐藏首页 block（null = 未启用）
   */
  homeAfterWaterFallStartIndex: number | null;
}

export interface GlobalActions {
  setIsGlobalLoading: (isLoading: GlobalState['isGlobalLoading']) => void;
  resetGlobalState: () => void;
  setCurrentYear: (year: GlobalState['currentYear']) => void;
  setWaiMode: (waiMode: GlobalState['waiMode']) => void;
  setLanguage: (language: GlobalState['language']) => void; // 设置语言的方法
  setCurrencyList: (currencyList: GlobalState['currencyList']) => void;
  setCurrency: (currency: GlobalState['currency']) => void;
  setCurrencyReady: (currencyReady: GlobalState['currencyReady']) => void;
  setCurrencyByName: (name: GlobalState['currency']['name']) => void;
  setCountryList: (countryList: GlobalState['countryList']) => void;
  setCountrySiteList: (countrySiteList: GlobalState['countrySiteList']) => void;
  setPublicResourceData: (publicResourceData: GlobalState['publicResourceData']) => void;
  setWalletFlag: (walletFlag: GlobalState['walletFlag']) => void;
  setRefreshOrderDetailFlag: (
    refreshOrderDetailFlag: GlobalState['refreshOrderDetailFlag'],
  ) => void;
  // 登录注册弹窗控制方法 - 支持重载
  setShowLoginRegisterDialog: {
    (show: boolean): void;
    (config: {
      show: boolean;
      eventType?: string;
      situation?: string;
      initiative?: boolean;
      initialEmail?: string;
      /** 弹窗展示场景；payment 会启用支付专属 UI，不决定接口 login_scene。 */
      scene?: LoginRegisterScene;
    }): void;
  };
  // 登录注册弹窗参数设置方法
  setLoginRegisterEventType: (eventType: GlobalState['loginRegisterEventType']) => void; // 登录注册事件类型
  setLoginRegisterInitiative: (initiative: GlobalState['LoginRegisterInitiative']) => void; // 登录注册主动触发
  setLoginSituation: (situation: GlobalState['loginSituation']) => void; // 登录场景
  setOnLoginClose: (onLoginClose: GlobalState['onLoginClose']) => void; // 登录弹窗关闭回调

  // 其他状态
  setInches: (inches: GlobalState['inches']) => void;
  setIsOpenSideNav: (isOpenSideNav: GlobalState['isOpenSideNav']) => void;
  setIsShowDtBanner: (isShowDtBanner: GlobalState['isShowDtBanner']) => void;
  setIsShowDtBannerByPage: (isShowDtBannerByPage: GlobalState['isShowDtBannerByPage']) => void;
  setIsShowAppDownloadBanner: (
    isShowAppDownloadBanner: GlobalState['isShowAppDownloadBanner'],
  ) => void;
  setScrollHash: (hash: GlobalState['scrollHash']) => void;
  setIsShowScrollToTop: (isShowScrollToTop: GlobalState['isShowScrollToTop']) => void;
  setIsHalfStickyRightBottomIcons: (
    isHalfStickyRightBottomIcons: GlobalState['isHalfStickyRightBottomIcons'],
  ) => void;
  setIsShowHeaderNav: (isShowHeaderNav: GlobalState['isShowHeaderNav']) => void;
  setIsShowFooterNav: (isShowFooterNav: GlobalState['isShowFooterNav']) => void;
  setIsHeaderDarkMode: (isHeaderDarkMode: GlobalState['isHeaderDarkMode']) => void;
  setIsShowFooterSubscribe: (isShowFooterSubscribe: GlobalState['isShowFooterSubscribe']) => void;
  setJoinFreeDialogInfo: (joinFreeDialogInfo: GlobalState['joinFreeDialogInfo']) => void;

  setIsMobileScreen: (isMobileScreen: GlobalState['isMobileScreen']) => void;
  setInAppH5: (inAppH5: GlobalState['inAppH5']) => void;
  setPublicHalfPrice: (publicHalfPrice: GlobalState['publicHalfPrice']) => void;
  setMemberLevelConfig: (memberLevelConfig: GlobalState['memberLevelConfig']) => void;
  setCompliancePolicies: (policies: GlobalState['compliancePolicies']) => void;
  setComplianceMarketingStatus: (status: GlobalState['complianceMarketingStatus']) => void;
  getMarketingStatus: () => Promise<GlobalState['complianceMarketingStatus']>;
  setZoomDisablerType: (zoomDisablerType: GlobalState['zoomDisablerType']) => void;
  // 客服相关方法
  setCustomerService: (service: Partial<CustomerServiceState>) => void;
  /** US 瀑布流 B：仍有下一页 → 锁住「瀑布流以下 + 底栏」（内部 `queueMicrotask`，防与 Footer 同轮竞态） */
  lockWaterFallBelow: (moduleIndex: number) => void;
  /** US 瀑布流 B：全部加载完 → 解锁（恢复底栏、清 `homeAfterWaterFallStartIndex`） */
  unlockWaterFallBelow: (payload: {
    moduleIndex: number;
    pathname: string;
    isWap: boolean;
  }) => void;
  /** US 瀑布流 B：卸载时仅本块认领过才解锁 */
  unlockWaterFallBelowIfSelf: (payload: {
    moduleIndex: number;
    pathname: string;
    isWap: boolean;
  }) => void;
}

export type GlobalSlice = GlobalState & GlobalActions;

export const initialGlobalState: GlobalState = {
  isGlobalLoading: false,
  // TODO: 这里的时间戳会从后端接口获取，需要后续改一下
  currentYear: new Date().getUTCFullYear(),
  waiMode: false,
  language: 'en', // 默认语言为英语
  availableLanguages: ['en', 'zh', 'es', 'fr', 'de'], // 可用的语言列表
  currencyList: [],
  currency: {
    name: 'USD',
    full_symbol: '$',
    symbol: '$',
    exchange_rate: '1.000000',
    symbol_prefix: '$',
  },
  currencyReady: false,
  countryList: [], // 国家列表
  countrySiteList: [], // 国家站点列表
  publicResourceData: {},
  walletFlag: false, // 电子钱包开关
  refreshOrderDetailFlag: false,
  // 登录注册弹窗相关状态
  showLoginRegisterDialog: false,
  LoginRegisterInitiative: false,
  loginRegisterInitialEmail: '',
  loginRegisterScene: 'normal',
  loginRegisterEventType: '',
  loginSituation: '其他',
  onLoginClose: () => {},
  inches: false,
  isOpenSideNav: false,
  isShowDtBanner: true,
  isShowDtBannerByPage: true,
  isShowAppDownloadBanner: true,
  // 设置滚动
  scrollHash: {
    top: 0,
    flag: false,
  },
  isShowScrollToTop: false,
  isHalfStickyRightBottomIcons: false,
  isShowHeaderNav: true,
  isShowFooterNav: true,
  isHeaderDarkMode: false,
  isShowFooterSubscribe: true,
  joinFreeDialogInfo: {
    show: false,
  },

  isMobileScreen: false,
  inAppH5: isInZeloolApp(),
  publicHalfPrice: {},
  memberLevelConfig: [],
  compliancePolicies: null,
  complianceMarketingStatus: undefined,
  zoomDisablerType: {},
  // 客服相关状态初始值
  customerService: {
    showInstadesk: false,
    instadeskUrl: '',
    deskType: '',
    showShulexIframe: false,
    shulexIframeUrl: '',
  },
  sgtmPixelConfig: null,
  homeAfterWaterFallStartIndex: null,
};

export const createGlobalSlice: StateCreator<Store, [], [], GlobalSlice> = (set, get) => {
  return {
    // 使用当前状态中的值（如果存在），否则使用初始状态值
    ...initialGlobalState,

    // Actions
    setIsGlobalLoading: (isGlobalLoading) => set({ isGlobalLoading }),
    resetGlobalState: () => set(initialGlobalState),
    setCurrentYear: (timestamp) => set({ currentYear: timestamp }),
    setWaiMode: (waiMode) => {
      if (window.self === window.top) {
        localStorage.setItem('zl-blind-mode', waiMode.toString());
      }
      set({ waiMode });
    },
    setLanguage: (language) => set({ language }),
    setCurrencyList: (currencyList) => set({ currencyList }),
    setCurrency: (currency) => {
      // 如果是在iframe中，则不存储到localStorage
      if (window.self === window.top) {
        logger.info('setCurrency', currency);
        localStorage.setItem('zl-currency', JSON.stringify(currency));
      }
      set({ currency });
    },
    setCurrencyReady: (currencyReady) => set({ currencyReady }),
    setCurrencyByName: (name) => {
      const { currencyList } = get();
      const currency = currencyList.find((item) => item.name === name);
      if (!currency) {
        logger.error(`Currency ${name} not found`);
        return;
      }
      set({ currency });
    },
    setCountryList: (countryList) => set({ countryList }),
    setCountrySiteList: (countrySiteList) => set({ countrySiteList }),
    setPublicResourceData: (data) => set({ publicResourceData: data }),
    setWalletFlag: (walletFlag) => set({ walletFlag }),
    setRefreshOrderDetailFlag: (refreshOrderDetailFlag) => set({ refreshOrderDetailFlag }),
    // 登录注册弹窗控制方法 - 支持重载
    // 当显示登录弹窗时，会自动关闭快捷领券弹窗，以避免多个弹窗同时显示
    // scene 只控制弹窗展示/初始化；登录接口的 login_scene 由当前 pathname 独立判断。
    // @param showOrConfig - boolean | { show: boolean, eventType?: string, situation?: string, initiative?: boolean, initialEmail?: string, scene?: LoginRegisterScene }
    setShowLoginRegisterDialog: (showOrConfig) => {
      // 获取 globalDialogSlice 的 setQuickCouponDialogShow 方法
      const { setQuickCouponDialogShow } = get() as any;

      // 判断参数类型
      if (typeof showOrConfig === 'boolean') {
        // 原有的boolean用法，保持完全兼容
        if (showOrConfig) {
          // 显示登录弹窗时，关闭快捷领券弹窗
          setQuickCouponDialogShow?.(false);
          set({
            showLoginRegisterDialog: true,
            loginRegisterInitialEmail: '',
            loginRegisterScene: 'normal',
          });
        } else {
          set({
            showLoginRegisterDialog: false,
            loginRegisterInitialEmail: '',
            loginRegisterScene: 'normal',
          });
        }
      } else {
        // 新的配置对象用法
        const { show, eventType, situation, initiative, initialEmail, scene } = showOrConfig;
        logger.info('setShowLoginRegisterDialog', showOrConfig);
        const updates: any = {
          showLoginRegisterDialog: show,
          loginRegisterInitialEmail: show ? initialEmail || '' : '',
          // 普通入口不传 scene 时始终回落 normal，避免复用上一次支付场景。
          loginRegisterScene: show ? scene || 'normal' : 'normal',
        };

        // 如果要显示登录弹窗，关闭快捷领券弹窗
        if (show) {
          setQuickCouponDialogShow?.(false);
        }

        // 可选设置其他属性
        if (eventType !== undefined) {
          updates.loginRegisterEventType = eventType;
        }
        if (situation !== undefined) {
          updates.loginSituation = situation;
          // 如果设置了situation，同时存储到sessionStorage
          if (window.self === window.top) {
            sessionStorage.setItem('zl-login-situation-new', situation);
          }
        }
        if (initiative !== undefined) {
          updates.LoginRegisterInitiative = initiative;
        }

        set(updates);
      }
    },

    // 登录注册弹窗参数设置方法
    // 登录注册事件类型
    setLoginRegisterEventType: (eventType) => set({ loginRegisterEventType: eventType }),
    // 登录场景
    setLoginSituation: (situation) => {
      // 如果是在iframe中，则不存储到sessionStorage
      if (window.self === window.top) {
        sessionStorage.setItem('zl-login-situation-new', situation);
      }
      set({ loginSituation: situation });
    },
    // 登录注册主动触发
    setLoginRegisterInitiative: (initiative) => set({ LoginRegisterInitiative: initiative }),
    // 登录弹窗关闭回调
    setOnLoginClose: (onLoginClose) => set({ onLoginClose }),

    // 其他状态
    setInches: (inches) => set({ inches }),
    setIsOpenSideNav: (isOpenSideNav) => set({ isOpenSideNav }),
    setIsShowDtBanner: (isShowDtBanner) => set({ isShowDtBanner }),
    setIsShowDtBannerByPage: (isShowDtBannerByPage) => set({ isShowDtBannerByPage }),
    setIsShowAppDownloadBanner: (isShowAppDownloadBanner) => set({ isShowAppDownloadBanner }),

    setScrollHash: ({ top, flag }) => {
      // 如果是在iframe中，则不存储到localStorage
      if (window.self === window.top) {
        if (JSON.parse(localStorage.getItem('zl-scrollHash'))) {
          localStorage.setItem('zl-scrollHash', JSON.stringify({ top, flag }));
          set({
            scrollHash: { top, flag },
          });
        } else {
          set({ scrollHash: { top, flag } });
          localStorage.setItem('zl-scrollHash', JSON.stringify({ top, flag }));
        }
      }
    },

    setIsShowScrollToTop: (isShowScrollToTop) => set({ isShowScrollToTop }),
    setIsHalfStickyRightBottomIcons: (isHalfStickyRightBottomIcons) =>
      set({ isHalfStickyRightBottomIcons }),
    setIsShowHeaderNav: (isShowHeaderNav) => set({ isShowHeaderNav }),
    setIsShowFooterNav: (isShowFooterNav) => set({ isShowFooterNav }),
    setIsHeaderDarkMode: (isHeaderDarkMode) => set({ isHeaderDarkMode }),
    setIsShowFooterSubscribe: (isShowFooterSubscribe) => set({ isShowFooterSubscribe }),
    setJoinFreeDialogInfo: (joinFreeDialogInfo) => set({ joinFreeDialogInfo }),

    setIsMobileScreen: (isMobileScreen) => set({ isMobileScreen }),
    setInAppH5: (inAppH5) => set({ inAppH5 }),
    setPublicHalfPrice: (publicHalfPrice) => set({ publicHalfPrice }),
    setMemberLevelConfig: (memberLevelConfig) => set({ memberLevelConfig }),
    setCompliancePolicies: (compliancePolicies) => set({ compliancePolicies }),
    setComplianceMarketingStatus: (complianceMarketingStatus) => set({ complianceMarketingStatus }),
    getMarketingStatus: async () => {
      try {
        const res = await fetchComplianceMarketingStatus();
        const complianceMarketingStatus = res?.data || null;
        set({ complianceMarketingStatus });
        return complianceMarketingStatus;
      } catch (error) {
        logger.error(error, 'fetchComplianceMarketingStatus failed');
        set({ complianceMarketingStatus: null });
        return null;
      }
    },
    setZoomDisablerType: (zoomDisablerType) =>
      set({ zoomDisablerType: { ...get().zoomDisablerType, ...zoomDisablerType } }),
    // 客服相关方法 - 合并更新客服状态
    setCustomerService: (service) =>
      set({
        customerService: { ...get().customerService, ...service },
      }),

    lockWaterFallBelow: (moduleIndex) => {
      if (get().homeAfterWaterFallStartIndex !== null) return;
      queueMicrotask(() => {
        if (get().homeAfterWaterFallStartIndex !== null) return;
        set({ isShowFooterNav: false, homeAfterWaterFallStartIndex: moduleIndex });
      });
    },

    unlockWaterFallBelow: ({ moduleIndex, pathname, isWap }) => {
      const { homeAfterWaterFallStartIndex } = get();
      if (homeAfterWaterFallStartIndex !== null && homeAfterWaterFallStartIndex !== moduleIndex) {
        return;
      }
      set({
        isShowFooterNav: checkFooterConfig(pathname, isWap).isShowFooterNav,
        homeAfterWaterFallStartIndex: null,
      });
    },

    unlockWaterFallBelowIfSelf: ({ moduleIndex, pathname, isWap }) => {
      if (get().homeAfterWaterFallStartIndex !== moduleIndex) return;
      set({
        isShowFooterNav: checkFooterConfig(pathname, isWap).isShowFooterNav,
        homeAfterWaterFallStartIndex: null,
      });
    },
  };
};

/* 使用示例：

// 🟢 现有用法完全保持不变 - 零改动
setShowLoginRegisterDialog(true);   // 打开弹窗
setShowLoginRegisterDialog(false);  // 关闭弹窗

// 🟢 现有组合用法也不变
setLoginRegisterEventType('wish_register');
setShowLoginRegisterDialog(true);

// 🆕 新增的便捷用法 - 一次调用设置多个属性
setShowLoginRegisterDialog({
  show: true,
  eventType: 'wish_register',
  situation: '首页登录',
  initiative: true
});

// 🆕 也可以只设置部分属性
setShowLoginRegisterDialog({
  show: true,
  eventType: 'shopping_cart_checkout'
});

// 支付页已校验邮箱注册状态：使用支付专属弹窗，并直接进入该邮箱的验证码登录步骤。
// scene 仅控制弹窗 UI/初始化；接口 login_scene 仍根据用户发起登录时的当前 pathname 判断。
setShowLoginRegisterDialog({
  show: true,
  scene: 'payment',
  initialEmail: email
});

// 🆕 快速关闭并重置
setShowLoginRegisterDialog({
  show: false,
  eventType: '',
  situation: '其他'
});

*/
